const HOUR_MS = 60 * 60 * 1000;

/** Escalating snooze applied after each close of the toolbar transcription alert (index = close count − 1):
 *  24h after the 1st close, 48h after the 2nd, 5 days after the 3rd. After the 3rd close the toolbar alert is
 *  suppressed for good — only the in-context (panel) alert remains (rule agreed with product, VS-1596). */
export const TRANSCRIPTION_ALERT_DISMISS_WINDOWS_MS = [24 * HOUR_MS, 48 * HOUR_MS, 5 * 24 * HOUR_MS];

/** Whether the toolbar alert is still hidden given how many times it has been closed and when it was last
 *  closed. `count <= 0` → never closed (show); `count > windows.length` → permanently suppressed; otherwise
 *  hidden until the matching window elapses. */
export function isTranscriptionAlertSnoozed(count: number, lastDismissedAtMs: number, nowMs: number): boolean {
    if (count <= 0) {
        return false;
    }
    if (count > TRANSCRIPTION_ALERT_DISMISS_WINDOWS_MS.length) {
        return true;
    }
    return nowMs - lastDismissedAtMs < TRANSCRIPTION_ALERT_DISMISS_WINDOWS_MS[count - 1];
}
